export type ThemeId = 'light' | 'dark' | 'sepia' | 'eyecare' | 'chalkboard' | 'parchment';
export type ThemeMode = ThemeId | 'system';
export type AccentId = 'ochre' | 'ink' | 'moss' | 'indigo' | 'crimson' | 'custom';
export type DensityId = 'compact' | 'comfortable' | 'spacious';
export type GridId = 'dots' | 'grid' | 'lines' | 'blank';
export type RadiusId = 'crisp' | 'soft' | 'pillowy' | 'velvet';
export type SurfaceStyleId = 'floating' | 'flush' | 'hybrid';
export type ShadowId = 'flat' | 'soft' | 'pronounced' | 'dramatic';
export type TypeScaleId = 'compact' | 'standard' | 'large';
export type MotionId = 'reduced' | 'performance' | 'standard' | 'advanced' | 'rich';
export type RenderingId = 'performance' | 'balanced' | 'quality';

export interface ThemeState {
  theme: ThemeMode;
  accent: AccentId;
  customAccent?: `#${string}`;
  density: DensityId;
  grid: GridId;
  radius: RadiusId;
  surfaceStyle: SurfaceStyleId;
  shadow: ShadowId;
  typeScale: TypeScaleId;
  rendering: RenderingId;
  motion: MotionId;
}

export const DEFAULT_THEME_STATE: ThemeState = {
  theme: 'system',
  accent: 'ochre',
  density: 'comfortable',
  grid: 'dots',
  radius: 'pillowy',
  surfaceStyle: 'floating',
  shadow: 'soft',
  typeScale: 'standard',
  rendering: 'balanced',
  motion: 'standard',
};

export interface ThemeContextValue extends ThemeState {
  /** Resolved theme (if theme==='system', this is light|dark). */
  resolvedTheme: ThemeId;
  setTheme: (t: ThemeMode) => void;
  setAccent: (a: AccentId, hex?: `#${string}`) => void;
  setDensity: (d: DensityId) => void;
  setGrid: (g: GridId) => void;
  setRadius: (r: RadiusId) => void;
  setSurfaceStyle: (s: SurfaceStyleId) => void;
  setShadow: (s: ShadowId) => void;
  setTypeScale: (t: TypeScaleId) => void;
  setRendering: (r: RenderingId) => void;
  setMotion: (m: MotionId) => void;
  setState: (patch: Partial<ThemeState>) => void;
  reset: () => void;
}
